import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Meta Pixel Code
    ;
    (function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      // Append to head instead of trying to find first script tag
      const head = b.getElementsByTagName('head')[0];
      if (head) {
        head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize Meta Pixel after script loads
    if (window.fbq) {
      window.fbq('init', '1350405659444999');
      window.fbq('track', 'PageView');
    }
  }, []);
  return <noscript data-id="element-106">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1350405659444999&ev=PageView&noscript=1" alt="" data-id="element-107" />
    </noscript>;
}